import Checkbox, { CheckboxProps } from '@material-ui/core/Checkbox';
import { withStyles } from '@material-ui/core/styles';

const WhiteCheckbox = withStyles((theme) => ({
  root: {
    color: theme.palette.background.paper,
    '&$checked': {
      color: theme.palette.background.paper
    }
  },
  checked: {}
}))((props: CheckboxProps) => <Checkbox color="default" {...props} />);

export default WhiteCheckbox;
